'use client'

import * as React from 'react'

import { cn } from '../../lib'

interface StepperProps {
  currentStep: number
  totalSteps: number
  className?: string
  variant?: 'default' | 'blue' | 'green' | 'red'
}

const Stepper = React.forwardRef<HTMLDivElement, StepperProps>(
  ({ className, currentStep = 1, totalSteps = 5, variant = 'default', ...props }, ref) => {
    const getActiveColor = (variant: string) => {
      switch (variant) {
        case 'blue':
          return 'bg-[#6184FF]'
        case 'green':
          return 'bg-green-500'
        case 'red':
          return 'bg-[#FD6771]'
        default:
          return 'bg-gray-900'
      }
    }

    const clampedCurrentStep = Math.max(1, Math.min(totalSteps, currentStep))

    return (
      <div ref={ref} className={cn('flex gap-1', className)} {...props}>
        {Array.from({ length: totalSteps }).map((_, index, originArr) => {
          const stepNumber = index + 1
          const isActive = stepNumber <= clampedCurrentStep
          const isFirstStep = index === 0
          const isLastStep = index === originArr.length - 1

          return (
            <div
              key={index}
              className={cn(
                'h-1 flex-1 transition-colors duration-200',
                isActive ? getActiveColor(variant) : 'bg-gray-200',
                isFirstStep && 'rounded-l-lg',
                isLastStep && 'rounded-r-lg',
              )}
            />
          )
        })}
      </div>
    )
  },
)

Stepper.displayName = 'Stepper'

export { Stepper, type StepperProps }
